module.exports = __webpack_public_path__ + "img/navLogo.3d17385e.png";